import { render } from "./atasAlunos.vue?vue&type=template&id=14f77471&scoped=true"
import script from "./atasAlunos.vue?vue&type=script&lang=js"
export * from "./atasAlunos.vue?vue&type=script&lang=js"

import "./atasAlunos.vue?vue&type=style&index=0&id=14f77471&lang=scss&scoped=true"
import "./atasAlunos.vue?vue&type=style&index=1&id=14f77471&lang=css"
import "./atasAlunos.vue?vue&type=style&index=2&id=14f77471&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f77471"]])

export default __exports__